var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    [
      _c(
        "el-input-number",
        _vm._b(
          {
            attrs: {
              min: _vm.min,
              max: typeof _vm.endValue_ === "number" ? _vm.endValue_ : _vm.max,
              size: "mini",
              "controls-position": "right",
              placeholder: _vm.minPlaceholder,
            },
            on: { input: _vm.updateValue },
            model: {
              value: _vm.startValue_,
              callback: function ($$v) {
                _vm.startValue_ = $$v
              },
              expression: "startValue_",
            },
          },
          "el-input-number",
          _vm.$attrs,
          false
        )
      ),
      _vm._v(" " + _vm._s(_vm.connector) + " "),
      _c(
        "el-input-number",
        _vm._b(
          {
            attrs: {
              min:
                typeof _vm.startValue_ === "number" ? _vm.startValue_ : _vm.min,
              max: _vm.max,
              size: "mini",
              "controls-position": "right",
              placeholder: _vm.maxPlaceholder,
            },
            on: { input: _vm.updateValue },
            model: {
              value: _vm.endValue_,
              callback: function ($$v) {
                _vm.endValue_ = $$v
              },
              expression: "endValue_",
            },
          },
          "el-input-number",
          _vm.$attrs,
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }